import React from 'react';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import ValuePropositions from '@/components/ValuePropositions';
import ServiceCatalog from '@/components/ServiceCatalog';
import TrustCompliance from '@/components/TrustCompliance';
import Footer from '@/components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen" data-testid="home-page">
      <Header />
      <HeroSection />
      <ValuePropositions />
      <ServiceCatalog />
      <TrustCompliance />
      <Footer />
    </div>
  );
}
